// removed by extract-text-webpack-plugin
module.exports = {"switch":"UserItem__switch__2i2Fr","location":"UserItem__location__2bzzW","blocked":"UserItem__blocked__3_jtJ"};


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard/users/UserItem/UserItem.scss
// module id = 237
// module chunks = 0